import TitleWithDescription from './TitleWithDescription';
import { TitleWithDescriptionProps, TitleWithDescriptionValueProps } from './types';

export type { TitleWithDescriptionProps, TitleWithDescriptionValueProps };
export default TitleWithDescription;
